// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Y_nA","colBig":"styles_colBig__2P7Sk","colSmall":"styles_colSmall__1RlyF","shopifyNameWrapper":"styles_shopifyNameWrapper__2y1B6"};